<template>
    

    <Parrilla3Productos v-if="mostrar == true && outputParrilla == 'card'"
      :ProductoSeleccionadoEnParrilla="$store.state.ProductoSeleccionadoEnParrilla"
      :AddonsSeleccionados="$store.state.AddonsSeleccionados"
      :Precios="$store.state.Precios"
      :urlPresupuestos="urlPresupuestos"
      :idPresupuesto="idPresupuesto"
      :productoAnterior="productoAnterior"
      :PeriodoSeleccionado="$store.state.PeriodoSeleccionado"
      :PeriodosEscritos="$store.state.PeriodosEscritos"
      :PricingMatrix="$store.state.Pricing.products"
      :trackingUrlSave="trackingUrlSave"
      :urlActiveCampaign="urlActiveCampaign"
      :conversionValue=conversionValue
      :name="eventName"
      :filter="filtro"
      :numeroColumnasMaximo="Number(numeroColumnasMaximo)"
      :UrlDescargaPresupuesto="UrlDescargaPresupuesto"
      :mostrarInfo="mostrarInfo"
    ></Parrilla3Productos>
    

    <ParrillaLista v-if="mostrar == true && outputParrilla == 'list'"
      :ProductoSeleccionadoEnParrilla="$store.state.ProductoSeleccionadoEnParrilla"
      :AddonsSeleccionados="$store.state.AddonsSeleccionados"
      :Precios="$store.state.Precios"
      :urlPresupuestos="urlPresupuestos"
      :idPresupuesto="idPresupuesto"
      :productoAnterior="productoAnterior"
      :PeriodoSeleccionado="$store.state.PeriodoSeleccionado"
      :PeriodosEscritos="$store.state.PeriodosEscritos"
      :PricingMatrix="$store.state.Pricing.products"
      :trackingUrlSave="trackingUrlSave"
      :urlActiveCampaign="urlActiveCampaign"
      :conversionValue=conversionValue
      :name="eventName"
      :filter="filtro"
      :numeroColumnasMaximo="Number(numeroColumnasMaximo)"
      :UrlDescargaPresupuesto="UrlDescargaPresupuesto"
      :mostrarInfo="mostrarInfo"
    ></ParrillaLista>

  </template>
  <script>
  
  
  import Parrilla3Productos from './component/Parrilla3Productos.vue'
  import ParrillaLista from './component/ParrillaLista.vue'
  import RegistroUsuarioUnico from './component/UserRegistry'

  
  
  export default {
    name: 'App',
    components : { Parrilla3Productos, ParrillaLista},
    data: function () {
                return {
                  filtro: [],
                  idPresupuesto: null,
                  tipoPresupuesto: "",
                  numeroColumnasMaximo: "1",
                  urlPresupuestos: "",
                  productoAnterior: productoAnteriorID,
                  conversionValue: 2,
                  eventName: "",
                  mostrar: false,
                  UrlDescargaPresupuesto: null,
                  mostrarInfo: true,
                  outputParrilla: "card"

                }
              },


     mounted: async function(){

          // Inicializar PeriodoSeleccionado desde constante externa si existe (antes de cargar datos)
          this.inicializarPeriodoDesdeHTML();

          if (urlProductos) {

               if (!this.$store.Pricing){

                    this.$store.dispatch('getDataJson', urlProductos);

               } else {

                    this.mostrar = true;

                    let registro = await RegistroUsuarioUnico.registrarUsuarioWeb(ApiuserRegistry, ipEquipo);

                    if (registro.status == "KO")
                    {
                         console.log(registro);
       
                    }

               }


               this.$watch('$store.state.Pricing', async function () {

                    this.mostrar = true;

                    // Re-establecer PeriodoSeleccionado después de cargar datos para asegurar que el valor del HTML tenga prioridad
                    this.inicializarPeriodoDesdeHTML();

                    let registro = await RegistroUsuarioUnico.registrarUsuarioWeb(ApiuserRegistry, ipEquipo);

                    if (registro.status == "KO")
                    {
                         console.log(registro);
       
                    }

               });

          } else {

               this.mostrar = false;


          }

                         

          let Id_Presupuesto = document.getElementById("idPresupuesto").value;
          let columnas = document.getElementById("numeroColumnasMaximo").value;
          let urlPresupuestos = document.getElementById("urlPresupuestos").value;

          if (Id_Presupuesto)
          {

               this.idPresupuesto = Id_Presupuesto;

          }

          if (columnas)
          {

               this.numeroColumnasMaximo = columnas;

          }


          if (listaProductos)
          {

               this.filtro = listaProductos;

          }

     
          if (urlPresupuestos)
          {

               this.urlPresupuestos = urlPresupuestos;

          }

          if (productoAnteriorID)
          {

               this.productoAnterior = productoAnteriorID;

          }


          if (conversionValue)
          {

               this.conversionValue = conversionValue;

          }
                    
          if (eventName)
          {

               this.eventName = eventName;

          }


          if (trackingUrlSave) {

               this.trackingUrlSave = trackingUrlSave;


          }

          if (urlActiveCampaign) {


               this.urlActiveCampaign = urlActiveCampaign;


          }

          if (UrlDescargaPresupuesto) {


               this.UrlDescargaPresupuesto = UrlDescargaPresupuesto;

          }

          if (mostrarInfo) {


               this.mostrarInfo = mostrarInfo;

          } else {

               this.mostrarInfo = mostrarInfo;


          }


          if (outputParrilla) {


               this.outputParrilla = outputParrilla;

          }

    },
    methods: {
          inicializarPeriodoDesdeHTML: function() {
               // Inicializar PeriodoSeleccionado desde constante externa si existe
               if (typeof window.PeriodoSeleccionado !== 'undefined' && window.PeriodoSeleccionado) {
                    console.log('Inicializando PeriodoSeleccionado desde HTML:', window.PeriodoSeleccionado);
                    this.$store.commit('resetPeriodoSeleccionado', window.PeriodoSeleccionado);
               } else if (typeof PeriodoSeleccionado !== 'undefined' && PeriodoSeleccionado) {
                    // Fallback: intentar sin window por si está en scope local
                    console.log('Inicializando PeriodoSeleccionado (sin window):', PeriodoSeleccionado);
                    this.$store.commit('resetPeriodoSeleccionado', PeriodoSeleccionado);
               }
          }
    }
  
  }
  </script>
